<div class="form-layout-compact scrollable-y" xmlns="http://www.w3.org/1999/html">
    @if (spec) {
        @if (reportHasBaseFilter()) {
            <div class="lm-builder-base-filter-container">
                    <div
                        id="lm-builder-report-base-filter"
                        data-automation-id="lm-builder-report-base-filter-input"
                        soho-tooltip
                        class="tag">
                        <svg
                            class="icon"
                            focusable="false"
                            aria-hidden="true"
                            role="presentation"
                            soho-tooltip
                            [popover]=true
                            [title]="'PreAppliedFilter' | translate"
                            [content]="reportBaseFilter">
                            <use [attr.xlink:href]="'#icon-info'"></use>
                        </svg>
                        <p [ngClass]="this.canRevertBaseFilter() ? 'strikethrough' : ''">{{ 'PreAppliedFilter' | translate }}</p>
                        @if (this.canRevertBaseFilter()) {
                            <svg
                                class="icon"
                                focusable="false"
                                aria-hidden="true"
                                role="presentation"
                                soho-tooltip
                                [content]="'UndoRemovePreAppliedFilter' | translate"
                                (click)="revertReportBasFilter()">
                                <use [attr.xlink:href]="'#icon-undo'"></use>
                            </svg>
                        } @else {
                            <svg
                                    class="icon"
                                    focusable="false"
                                    aria-hidden="true"
                                    role="presentation"
                                    soho-tooltip
                                    [content]="'RemovePreAppliedFilter' | translate"
                                    (click)="removeReportBaseFilter()">
                                <use [attr.xlink:href]="'#icon-close-small'"></use>
                            </svg>
                        }
                    </div>
            </div>
           <div class="tag"><span>{{ 'And' | translate }}</span></div>
        }
        <div
            class="lm-builder-filter-container field"
            cdkDropList
            [id]="LMBuilderModel.INSTANCE_SELECTION"
            [cdkDropListConnectedTo]="[LMBuilderModel.FACADE_FIELD_PICKER_FIELDS_LIST]"
            [cdkDropListData]="LMBuilderModel.INSTANCE_SELECTION"
            [cdkDropListEnterPredicate]="canDrop"
            (cdkDropListDropped)="drop($event)">
            <textarea
                [attr.id]="'lm-builder-list-filter'"
                data-automation-id="lm-builder-list-filter"
                spellcheck="false"
                soho-textarea
                soho-alert
                soho-trackdirty
                [(ngModel)]="filterCriteria"
                (ngModelChange)="this.instanceSelectionValidator$.next($event)">
            </textarea>
        </div>
        <div class="lm-build-custom-filter">
            <button
                id="lm-builder-custom-filter-link"
                data-automation-id="lm-builder-custom-filter-link"
                soho-button="tertiary"
                (click)="onAddCustomFilterClicked()">{{ 'Builder' | translate }}</button>
        </div>

        <div class="empty-title">
            <div class="lm-builder-empty-message-container" soho-emptymessage
                 [info]="'CreateFilterByDraggingMessage' | translate">
            </div>
        </div>
    }
</div>



